import { partition } from 'es-toolkit';
import React from 'react';
import AddIcon from '@mui/icons-material/Add';
import { Grid, Stack, Typography } from '@mui/material';

import { hasSupervisorFeatureFlag } from '@paragon/login-tools';
import { naturalSortByProperty } from '@paragon/utilities';

import { showCreateTrailerDialog } from '../../actions/dialogActions';
import { RootState } from '../../store';
import { useAppDispatch, useAppSelector } from '../hooks';
import { TrailerCard } from '../interface/cards/TrailerCard';
import { ResponsiveButtonBar } from '../interface/ResponsiveButtonBar';

export function TrailersPage() {
  const dispatch = useAppDispatch();
  const isSupervisor = useAppSelector(hasSupervisorFeatureFlag);
  const trailersState = useAppSelector((state: RootState) => state.trailers);

  if (trailersState.status === 'loading' || trailersState.status === 'catastrophicallyFailed') return null;

  // Archived trailers will appear at the end of the list
  const [trailers, archivedTrailers] = partition(Object.values(trailersState.trailers), (trailer) => !trailer.archived);
  const orderedTrailersList = naturalSortByProperty(trailers, (trailer) => trailer.name).concat(
    naturalSortByProperty(archivedTrailers, (archivedTrailer) => archivedTrailer.name),
  );

  return (
    <Stack>
      <Stack direction="row" sx={{ alignItems: 'center' }}>
        <Typography variant="h3" gutterBottom sx={{ marginRight: 'auto' }}>
          Trailers
        </Typography>

        {isSupervisor && (
          <ResponsiveButtonBar
            breakpoint="sm"
            icon={<AddIcon />}
            actions={[['Create Trailer', () => void dispatch(showCreateTrailerDialog())]]}
          />
        )}
      </Stack>
      <Grid container sx={{ alignItems: 'stretch' }} spacing={1}>
        {orderedTrailersList.map((trailer) => (
          <Grid key={trailer.guid} size={{ xs: 12, md: 6 }}>
            <TrailerCard trailer={trailer} />
          </Grid>
        ))}
      </Grid>
    </Stack>
  );
}
